import React from 'react';
import { formatRHValue } from '../utils/rhFormatters';

function RHInfoField({ label, value, sensitive = false, hidden = false, children }) {
  const displayedValue = sensitive && hidden ? '••••••••' : formatRHValue(value);

  return (
    <div className="rh-info-field">
      <span className="rh-info-field__label">{label}</span>
      <span className="rh-info-field__value">{children ?? displayedValue}</span>
    </div>
  );
}

export default RHInfoField;
